module.exports = __webpack_public_path__ + "media/courses/curricula/images/preview-mode-f9a08ab2e146dfb4ace6fdc24a0bf293.svg";